import { useCallback, useEffect } from 'react';
import { isInteractiveElement } from '@bynder-studio/misc';
import { isCtrlKey } from 'packages/helpers/hotKeys';
import { useIsModalOpen } from 'packages/hooks/useIsModalOpen';

const useVisibilityControlsShortcuts = ({ toggleVisibility }: { toggleVisibility?: () => void }) => {
    const isModalOpen = useIsModalOpen();

    const handleKeyDown = useCallback(
        (e: KeyboardEvent): void => {
            if (isInteractiveElement(e) || isCtrlKey(e) || e.shiftKey || isModalOpen) {
                return;
            }

            switch (e.code) {
                case 'KeyS': {
                    if (toggleVisibility) {
                        toggleVisibility();
                    }

                    break;
                }

                default:
                    break;
            }
        },
        [toggleVisibility, isModalOpen],
    );

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
};

export default useVisibilityControlsShortcuts;
